import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Mail, ArrowRight, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { AuthShell } from "@/components/auth/AuthShell";

const Welcome = () => (
  <>
    <Helmet>
      <title>Your EchoCRM account is ready | EchoCRM</title>
      <meta name="description" content="Your EchoCRM trial has started. Check your inbox for the link to set your password and sign in." />
      <meta name="robots" content="noindex" />
    </Helmet>

    <AuthShell
      eyebrow="Payment confirmed"
      title="Your account is ready."
      subtitle="We've created your EchoCRM workspace and started your 7-day free trial."
      footer={
        <>
          Already set your password?{" "}
          <Link to="/login" className="text-foreground hover:text-primary">Sign in</Link>
        </>
      }
    >
      <div className="space-y-5">
        <div className="rounded-lg border border-border bg-muted/40 p-4 space-y-3">
          <div className="flex items-start gap-3">
            <Mail className="h-4 w-4 mt-0.5 text-primary shrink-0" />
            <p className="text-[13px] leading-[1.6] text-muted-foreground">
              Check your inbox — we sent a secure link to set your password. It arrives from
              <span className="text-foreground"> EchoCRM</span> within a minute or two.
            </p>
          </div>
          <div className="flex items-start gap-3">
            <CheckCircle2 className="h-4 w-4 mt-0.5 text-primary shrink-0" />
            <p className="text-[13px] leading-[1.6] text-muted-foreground">
              Your Pro plan is already active — no extra setup needed.
            </p>
          </div>
        </div>

        <Button asChild size="lg" className="w-full">
          <Link to="/login">Go to sign in <ArrowRight className="h-4 w-4" /></Link>
        </Button>

        <p className="text-[12px] text-muted-foreground leading-[1.55]">
          Didn't get the email? Check spam, or use{" "}
          <Link to="/forgot-password" className="hover:text-foreground underline underline-offset-2">
            Forgot password
          </Link>{" "}
          with the email you paid with.
        </p>
      </div>
    </AuthShell>
  </>
);

export default Welcome;
